import Result from "@/core/common/Result";
import { IPodeVisualizarVisaoEstrategicaUseCase } from "../ports/PodeVisualizarVisaoEstrategicaUseCase";
import { injectable, inject } from "inversify";
import { PodeVisualizarVisaoEstrategicaGatewayAdapter } from "./PodeVisualizarVisaoEstrategicaGatewayAdapter";
import { type IPodeVisualizarVisaoEstrategicaGateway } from "../ports/PodeVisualizarVisaoEstrategicaGateway";
import "reflect-metadata";

@injectable()
export class PodeVisualizarVisaoEstrategicaUseCaseAdapter
  implements IPodeVisualizarVisaoEstrategicaUseCase
{
  @inject(PodeVisualizarVisaoEstrategicaGatewayAdapter)
  private readonly gateway!: IPodeVisualizarVisaoEstrategicaGateway;

  async execute(ids?: string[]): Promise<Result<boolean>> {
    const response = await this.gateway.podeVisualizar(ids);

    if (response.isFailure) return Result.ok(false);

    return Result.ok(response.getValue().temLucroRealOuPresumido);
  }
}
